export default __webpack_public_path__ + "static/media/36I-102635_-15561_0.7b94b11c.jpg";